function wrapCharsForCursive(element) {
  if (!element) return null;
  
  if (element.querySelectorAll('.aomai-phrase-char').length > 0) {
    return element.querySelectorAll('.aomai-phrase-char');
  }
  
  if (!element.textContent || !element.textContent.trim()) {
    return null;
  }
  
  const text = element.textContent.trim();
  const chars = text.split('');
  const fragment = document.createDocumentFragment();
  
  chars.forEach((char, index) => {
    const span = document.createElement('span');
    span.className = 'aomai-phrase-char';
    span.style.display = 'inline-block';
    span.textContent = char === ' ' ? '\u00A0' : char;
    fragment.appendChild(span);
  });
  
  element.innerHTML = '';
  element.appendChild(fragment);
  
  return element.querySelectorAll('.aomai-phrase-char');
}

function isSafari() {
  return /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent) ||
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.vendor && navigator.vendor.indexOf('Apple') > -1);
}

function initializePhraseAnimation() {
  const sections = document.querySelectorAll('.aomai-phrase');
  const useSimpleAnimation = isSafari();
  
  if (sections.length === 0) return;
  
  sections.forEach(section => {
    const titleEl = section.querySelector('.aomai-phrase-title');
    
    if (!titleEl) return;
    
    const chars = wrapCharsForCursive(titleEl);
    
    if (!chars || chars.length === 0) return;
    
    if (useSimpleAnimation) {
      chars.forEach((char) => {
        gsap.set(char, { opacity: 0 });
      });
      
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none none',
          once: true
        }
      });
      
      chars.forEach((char, index) => {
        const isSpace = char.textContent === '\u00A0' || char.textContent === ' ';
        const delay = isSpace ? 0.02 : 0.05;
        timeline.to(char, { opacity: 1, duration: 0.15 }, index * delay);
      });
    } else {
      chars.forEach((char, index) => {
        const isSpace = char.textContent === '\u00A0' || char.textContent === ' ';
        const randomRotation = isSpace ? 0 : (Math.random() - 0.5) * 4;
        const randomScale = isSpace ? 1 : 0.7 + Math.random() * 0.2;
        
        gsap.set(char, {
          opacity: 0,
          scale: randomScale,
          rotation: randomRotation,
          transformOrigin: 'center center'
        });
      });
      
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          end: 'bottom 20%',
          toggleActions: 'play none none none',
          once: true
        }
      });
      
      chars.forEach((char, index) => {
        const isSpace = char.textContent === '\u00A0' || char.textContent === ' ';
        const delay = isSpace ? 0.02 : 0.08;
        const duration = isSpace ? 0.1 : 0.2;
        timeline.to(char, {
          opacity: 1,
          scale: 1,
          rotation: 0,
          duration,
          ease: 'power2.out'
        }, index * delay);
      });
    }
  });
}

function waitForGSAPAndScrollTrigger(callback, maxAttempts = 50) {
  let attempts = 0;
  
  function check() {
    attempts++;
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      if (gsap.registerPlugin) {
        gsap.registerPlugin(ScrollTrigger);
      }
      callback();
    } else if (attempts < maxAttempts) {
      setTimeout(check, 100);
    } else {
      console.warn('GSAP ou ScrollTrigger não carregados após múltiplas tentativas');
    }
  }
  
  check();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    waitForGSAPAndScrollTrigger(initializePhraseAnimation);
  });
} else {
  waitForGSAPAndScrollTrigger(initializePhraseAnimation);
}
